<footer class="footer">
  <button class="back-button" (click)="back.emit()">
    Back
  </button>
</footer>
<div class="footer-box"></div>
